const APP_LOADING = "APP_LOADING";
const APP_DONE_LOADING = "APP_DONE_LOADING";
const APP_ERROR = "APP_ERROR";
const RESET_ERROR = "RESET_ERROR";

export const actions = {
  APP_LOADING,
  APP_DONE_LOADING,
  APP_ERROR,
  RESET_ERROR
};

